import { currentPage, slug, icap, tr } from '../global-pure.js'

const BugLink = ({ text = icap(tr('report a bug')), prefill = tr('Hi, I would like to report a bug regarding')+' '+currentPage()+'.\n...\n'}) => {
  return (<a href={`/${slug('contact')}?n=1&m=${encodeURIComponent(tr(prefill))}`}>{icap(tr(text))}</a>)
}

export default BugLink
